/* Woodlit G8 pages. P0: event binder only. SB-P1P2 keeps this block first and adds its modules after it. */
(function () {
  if (window.WLG8) return;
  window.WLG8 = { v: 'p0' };
  document.addEventListener('click', function (e) {
    var t = e.target, el = t && t.closest ? t.closest('[data-wl-g8-ev]') : null;
    if (!el || typeof window.wlTrack !== 'function') return;
    try {
      var host = el.closest('[data-wl-placement]');
      window.wlTrack(el.getAttribute('data-wl-g8-ev'), {
        placement: host ? host.getAttribute('data-wl-placement') : 'page',
        value: el.getAttribute('data-wl-g8-v') || ''
      });
    } catch (err) {}
  }, true);
})();
